import {useEffect, useState} from 'react';
import CustomFilterSelect from '../../../shared/customFilterSelect';
import './style.scss';
import {httpInterceptor} from "../../../API/interceptor";
import {toast} from "react-toastify";
import {getNeighborhoods} from "../../../API/apiService";

function CreateSchool({
                          setOpenModal,
                          sourceType,
                          schoolType,
                          municipalities,
                          users,
                          created
                      }) {
    // STATES //
    const [kidsGroup, setKidsGroup] = useState(true);
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState(null);
    const [formData, setFormData] = useState({
        schoolCode: '',
        municipality: '',
        neighborhood: '',
        type: '',
        year: '',
        resourceType: '',
        organization: '',
        groups: [],
        facilitator: ''
    });

    function onSelectMunicipality(selectName, id, name) {
        setSelectedMunicipality(id)
        formData.neighborhood = null;
        formData.municipality = id;
    }


    function onSelectType(selectName, id, name) {
        formData.type = id;
        formData.groups = [];
    }

    function addInfo(selectName, id, value) {
        setFormData({...formData, [selectName]: id});
    }

    function onSelectGroup(selectName, id, name) {
        if (id && selectName) {
            let group = formData.groups.find(g => g.selectName === selectName)
            if (group) {
                const found = name.indexOf('(');
                if (found !== -1) {
                    group.groupId = name.substring(0, found);
                } else {
                    group.groupId = name;
                }
            } else {
                group = {selectName: selectName, groupId: name, groupRange: ''}
                formData.groups.push(group);
            }

        }
    }

    function onSelectRange(selectName, id, name) {
        if (id && selectName) {
            let group = formData.groups.find(g => g.selectName === selectName)
            if (group) {
                group.groupRange = name;
            } else {
                group = {selectName: selectName, groupId: '', groupRange: name}
                formData.groups.push(group);
            }
        }
    }

    function onSelectNeighborhood(selectName, id, name) {
        formData.neighborhood = id;
    }

    function handleChange(e) {
        e.preventDefault();
        let {name, value} = e.target;
        if (name === 'schoolCode') {
            value = value?.toUpperCase();
        }
        setFormData({...formData, [name]: value});
    }


    function createSchool() {
        if (!formData.neighborhood || !formData.municipality) {
            toast('Por favor seleccione una Comuna y un Barrio valido', {
                type: 'warning'
            });
            return;
        }
        if (!formData.schoolCode) {
            toast('Por favor digite un Codigo de escuela', {
                type: 'warning'
            });
            return;
        }

        if (!formData.facilitator) {
            toast('Por favor seleccione un dinamizador', {
                type: 'warning'
            });
            return;
        }

        if (!formData.type) {
            toast('Por favor seleccione un Tipo de Escuela', {
                type: 'warning'
            });
            return;
        }
        if (!formData.year) {
            toast('Por favor seleccione un Año', {
                type: 'warning'
            });
            return;
        }
        const emptyGroup = !formData.groups || formData.groups.length === 0 || formData.groups.find(g => g.groupId === '' || g.groupRange === '');
        if (emptyGroup) {
            toast('Todos los grupos deben tener un rango de edad seleccionado', {
                type: 'warning'
            });
            return;
        }

        httpInterceptor
            .post(`schools`, formData)
            .then(res => {
                if (res && res.success) {
                    setOpenModal(false);
                    created(true);
                }
            })
            .catch(error => {
                if (error?.response?.data?.message?.code === '23505') {
                    toast('Codigo de Escuela ya existe', {
                        type: 'error'
                    });
                } else {
                    toast('Error creando escuela', {
                        type: 'error'
                    });
                }

            });

    }

    const ages1 = [
        {
            name: 'N1',
            id: '1'
        },
        {
            name: 'N2',
            id: '2'
        },
        {
            name: 'N3',
            id: '3'
        }
    ];

    const ages2 = [
        {
            name: 'N1',
            id: '4'
        },
        {
            name: 'N2',
            id: '5'
        },
        {
            name: 'N3',
            id: '6'
        }
    ];

    const ages3 = [
        {
            name: 'N1',
            id: '7'
        },
        {
            name: 'N2',
            id: '8'
        },
        {
            name: 'N3',
            id: '9'
        }
    ];

    const ages4 = [
        {
            name: 'N1',
            id: '10'
        },
        {
            name: 'N2',
            id: '11'
        },
        {
            name: 'N3',
            id: '12'
        }
    ];


    const adultsSelect = [
        {
            name: 'Grupo 4',
            id: '4',
        },
        {
            name: 'Grupo 5',
            id: '5',
        }
    ];

    const groupsKids = [
        {
            name: 'Grupo 1',
            id: '1'
        },
        {
            name: 'Grupo 2',
            id: '2'
        },
        {
            name: 'Grupo 3',
            id: '3'
        }
    ];

    async function getNeighborhoodsInfo() {
        if (selectedMunicipality) {
            const response = await getNeighborhoods(selectedMunicipality)
            if (response) {
                setNeighborhoods(response)
            }
        }
    }


    useEffect(() => {
        getNeighborhoodsInfo()
    }, [selectedMunicipality]);

    return (
        <section className='main-create-container'>
            <p className='title'> CREAR ESCUELA</p>
            <section className='create-container'>
                <label className='label' htmlFor=''>
                    <input
                        placeholder='Código de escuela'
                        type='text'
                        name='schoolCode'
                        className='input-form'
                        value={formData.schoolCode}
                        onChange={e => handleChange(e)}

                    />
                </label>
                <CustomFilterSelect
                    optionsList={schoolType}
                    setKidsGroup={setKidsGroup}
                    placeholder={'Tipo de escuela'}
                    addInfo={onSelectType}
                />
                <div className='groups-container'>
                    {kidsGroup ? (
                        <>
                            <CustomFilterSelect
                                placeholder={'Selecciona el grupo'}
                                optionsList={groupsKids}
                                addInfo={onSelectGroup}
                                keyName={1}
                            />
                            <CustomFilterSelect
                                placeholder={'seleccione rango'}
                                optionsList={ages1}
                                addInfo={onSelectRange}
                                keyName={1}
                            />

                            <CustomFilterSelect
                                placeholder={'Selecciona el grupo'}
                                optionsList={groupsKids}
                                addInfo={onSelectGroup}
                                keyName={2}
                            />
                            <CustomFilterSelect
                                placeholder={'seleccione rango'}
                                optionsList={ages2}
                                addInfo={onSelectRange}
                                keyName={2}
                            />

                            <CustomFilterSelect
                                placeholder={'Selecciona el grupo'}
                                optionsList={groupsKids}
                                addInfo={onSelectGroup}
                                keyName={3}
                            />
                            <CustomFilterSelect
                                placeholder={'seleccione rango'}
                                optionsList={ages3}
                                addInfo={onSelectRange}
                                keyName={3}
                            />
                        </>
                    ) : (
                        <>
                            <CustomFilterSelect
                                placeholder={'Selecciona el grupo'}
                                optionsList={adultsSelect}
                                addInfo={onSelectGroup}
                                keyName={4}
                            />
                            <CustomFilterSelect
                                placeholder={'seleccione rango'}
                                optionsList={ages4}
                                addInfo={onSelectRange}
                                keyName={4}
                            />

                            <CustomFilterSelect
                                placeholder={'Selecciona el grupo'}
                                optionsList={adultsSelect}
                                addInfo={onSelectGroup}
                                keyName={5}
                            />
                            <CustomFilterSelect
                                placeholder={'seleccione rango'}
                                optionsList={ages4}
                                addInfo={onSelectRange}
                                keyName={5}
                            />
                        </>
                    )}
                </div>
                <div className='dinamizador-container'>
                    <CustomFilterSelect
                        optionsList={users}
                        placeholder={'Nombre del dinamizador'}
                        addInfo={addInfo}
                        keyName='facilitator'
                    />
                </div>
                <div className='place-info-container'>
                    <CustomFilterSelect placeholder={'Comuna'} optionsList={municipalities}
                                        addInfo={onSelectMunicipality}/>
                    <CustomFilterSelect placeholder={'Barrios'} optionsList={neighborhoods}
                                        addInfo={onSelectNeighborhood}/>
                    <CustomFilterSelect
                        placeholder={'Tipo de recurso'}
                        optionsList={sourceType}
                        addInfo={addInfo}
                        keyName='resourceType'
                    />
                    <label className='label' htmlFor=''>
                        <input
                            placeholder='Año'
                            type='text'
                            name='year'
                            className='input-form'
                            value={formData.year}
                            onChange={e => handleChange(e)}
                        />
                    </label>
                </div>
                <div className='motherOrg-container'>
                    <label className='label' htmlFor=''>
                        <input
                            placeholder='Organizacion Madrina'
                            type='text'
                            name='organization'
                            className='input-form'
                            value={formData.organization}
                            onChange={e => handleChange(e)}

                        />
                    </label>
                </div>
                <div className='buttons-container'>
                    <button className='blue-site-button create'
                            onClick={() => createSchool()}
                    >CREAR
                    </button>
                    <button
                        className='button-white-border-blue'
                        onClick={() => setOpenModal(false)}>
                        CANCELAR
                    </button>
                </div>
            </section>
        </section>
    );
}

export default CreateSchool;
